import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Vehicle } from '@commons/models/domain/Vehicle';
import { isVehicleBlocked } from '@src/app/utils/params-binary-vehicle';

@Component({
  selector: 'app-lock-status',
  templateUrl: './lock-status.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  styleUrls: ['./lock-status.component.scss'],
})
export class LockStatusComponent {

  @Input('data') set data(value: Vehicle) {
    this.vehicle = value;
    this.setStatus(value);
  }

  public vehicle: Vehicle;
  public isBlocked: boolean;
  
  constructor() { }

  private setStatus(data: Vehicle): void {
    if (data?.blockerParametrId || data?.blockerParametrIdOut2) {
      this.isBlocked = isVehicleBlocked(data);
    }
  }

}
